import React from "react";
import get from "lodash/get";
import { StoryElement } from "@quintype/components";
import { DefaultStoryCard } from "../../DefaultStoryCard";
import { isTemplateWithAds } from "../../../utils/story";
import { WithStoryAds } from "../../WithStoryAds";
import "./detailed-quote.m.css";

export default function DetailedQuote({ story, card, counter = {} }) {
  const customStoryElements = card["story-elements"];

  const quoteEle = {};
  customStoryElements.map((element) => {
    if (element.type === "text" && element.subtype === "quote") {
      quoteEle.content = get(element, ["metadata", "content"], {});
      quoteEle.attribution = get(element, ["metadata", "attribution"], {});
    }
    if (element.type === "image") {
      quoteEle.image = element;
    }
  });
  const attrDetails = quoteEle?.attribution?.split(",");
  const showDefault = !quoteEle?.content || !quoteEle?.image;

  const componentToRender = (
    <div className="story-element story-element-detailed-quote" styleName="detailed-quote-wrapper">
      <div>
        <blockquote>{quoteEle?.content}</blockquote>
      </div>
      <div styleName="attribution">
        <div styleName="picture">
          <StoryElement element={quoteEle?.image} story={story} loadIframeOnClick />
        </div>
        <div styleName="details">
          <span>{attrDetails?.length > 0 && attrDetails[0]}</span>
          <span>{attrDetails?.length > 0 && attrDetails[1]}</span>
        </div>
      </div>
    </div>
  );

  const enableParagraphAds = isTemplateWithAds(story);
  if (showDefault) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }

  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
}
